import {
	rewardByID,
	rewardCreate,
	rewardDestroy,
	rewardList,
	rewardUpdate,
	rewardUserCreate,
	rewardUserDestroy,
	rewardPixelCreate,
} from '@/services/wallRewards.service'

export default {
	namespaced: true,
	state: {
		rewardList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		reward: {},
		rewardStatus: 'pending',
		rewardSaveStatus: 'init',
		rewardDeleteStatus: 'init',
		rewardUserSaveStatus: 'init',
		rewardUserDeleteStatus: 'init',
		rewardPixelSaveStatus: 'init',
	},
	getters: {
		getRewardList(state) {
			return state.rewardList
		},
		getReward(state) {
			return state.reward
		},
		getRewardUsers: state => {
			if (!state.reward || !state.reward.users) return []
			return state.reward.users.data || []
		},
		getRewardDeleteStatus(state) {
			return state.rewardDeleteStatus
		},
		getRewardSaveStatus(state) {
			return state.rewardSaveStatus
		},
		getRewardStatus(state) {
			return state.rewardStatus
		},
		getRewardUserSaveStatus(state) {
			return state.rewardUserSaveStatus
		},
		getRewardUserDeleteStatus(state) {
			return state.rewardUserDeleteStatus
		},
		getRewardPixelSaveStatus(state) {
			return state.rewardPixelSaveStatus
		},
	},
	mutations: {
		REWARD_LIST(state, value) {
			state.rewardList = value
		},
		SET_REWARD(state, value) {
			state.reward = value
		},
		ADD_REWARD_USER(state, user) {
			if (!state.reward.users) {
				state.reward.users = { data: [] }
			}
			state.reward.users.data.push(user)
		},
		REMOVE_REWARD_USER(state, userId) {
			if (state.reward.users && state.reward.users.data) {
				state.reward.users.data = state.reward.users.data.filter(user => user.id !== userId)
			}
		},
		ADD_REWARD_PIXEL(state, pixel) {
			if (!state.reward.pixels) {
				state.reward.pixels = { data: [] }
			}
			state.reward.pixels.data.push(pixel)
		},
		REWARD_STATUS(state, value) {
			state.rewardStatus = value
		},
		REWARD_SAVE_STATUS(state, value) {
			state.rewardSaveStatus = value
		},
		REWARD_DELETE_STATUS(state, value) {
			state.rewardDeleteStatus = value
		},
		REWARD_USER_SAVE_STATUS(state, value) {
			state.rewardUserSaveStatus = value
		},
		REWARD_USER_DELETE_STATUS(state, value) {
			state.rewardUserDeleteStatus = value
		},
		REWARD_PIXEL_SAVE_STATUS(state, value) {
			state.rewardPixelSaveStatus = value
		},
	},
	actions: {
		async fetchRewardList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('REWARD_STATUS', 'pending')
			commit('REWARD_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await rewardList(params)
				commit('REWARD_STATUS', 'init')
				commit('REWARD_LIST', data)
				return data
			} catch (error) {
				commit('REWARD_STATUS', 'init')
				throw error
			}
		},

		async fetchRewardByID({ commit }, params) {
			commit('REWARD_STATUS', 'pending')
			try {
				const { data } = await rewardByID(params)
				commit('REWARD_STATUS', 'init')
				commit('SET_REWARD', data.data)
				return data
			} catch (error) {
				commit('REWARD_STATUS', 'init')
				return error
			}
		},

		async saveNewReward({ commit }, params) {
			commit('REWARD_SAVE_STATUS', 'pending')
			try {
				const { data } = await rewardCreate(params)
				commit('REWARD_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('REWARD_SAVE_STATUS', 'init')
				throw error
			}
		},

		async updateReward({ commit }, params) {
			commit('REWARD_SAVE_STATUS', 'pending')
			try {
				const { data } = await rewardUpdate(params)
				commit('REWARD_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('REWARD_SAVE_STATUS', 'init')
				throw error
			}
		},

		async deleteRewardByID({ commit }, params) {
			commit('REWARD_DELETE_STATUS', 'pending')
			try {
				const { data } = await rewardDestroy(params)
				commit('REWARD_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('REWARD_DELETE_STATUS', 'error')
				return error
			}
		},

		// Reward Users Actions
		async addRewardUser({ commit, state }, { rewardId, userData }) {
			commit('REWARD_USER_SAVE_STATUS', 'pending')
			try {
				const { data } = await rewardUserCreate(rewardId, userData)

				if (state.reward && state.reward.id === rewardId) {
					commit('ADD_REWARD_USER', data.data)
				}

				commit('REWARD_USER_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('REWARD_USER_SAVE_STATUS', 'error')
				throw error
			}
		},

		async removeRewardUser({ commit, state }, { rewardId, userId }) {
			commit('REWARD_USER_DELETE_STATUS', 'pending')
			try {
				const { data } = await rewardUserDestroy(rewardId, userId)

				if (state.reward && state.reward.id === rewardId) {
					commit('REMOVE_REWARD_USER', userId)
				}

				commit('REWARD_USER_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('REWARD_USER_DELETE_STATUS', 'error')
				throw error
			}
		},

		// Reward Pixels Actions
		async addRewardPixel({ commit, state }, { rewardId, pixelData }) {
			commit('REWARD_PIXEL_SAVE_STATUS', 'pending')
			try {
				const { data } = await rewardPixelCreate(rewardId, pixelData)

				if (state.reward && state.reward.id === rewardId) {
					commit('ADD_REWARD_PIXEL', data.data)
				}

				commit('REWARD_PIXEL_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('REWARD_PIXEL_SAVE_STATUS', 'error')
				throw error
			}
		},
	},
}
